import { ProfileCollectionLayout, ProfileView } from "@authory-packages/core";

export const getV3ContentDimension = (viewType: ProfileView, isAboutPage: boolean, profileCollectionLayout?: ProfileCollectionLayout) => {
    if (isAboutPage) return 760;
    if (profileCollectionLayout === ProfileCollectionLayout.grid) return 1032;

    switch (viewType) {
        case ProfileView.TwoColumnThumbnail:
        case ProfileView.Masonry:
            return 1032;
        case ProfileView.OneColumnThumbnail:
            return 760;
        case ProfileView.List:
        case ProfileView.Text:
            return 816;
        default:
            return 0;
    }
};
